// Icons traced from the NewsGuard Figma design system (file GqO4TGZjzXSy6njBI1i0SM)
// so the UI matches the design exactly instead of relying on react-feather (whose
// look-alikes differ — e.g. stroke-width 2 vs the design's 1). `stroke` is
// currentColor so callers set the color via a text-* class.
//
// JSX ports of realnews-web's per-file icons in src/components/icons/
// (CheckCircleIcon.tsx, AlertTriangleIcon.tsx, EyeIcon.tsx, EyeOffIcon.tsx).
// Keep the SVG paths in sync.

export function CheckCircleIcon({ size = 18, className = "", ...props }) {
  // check-circle (Figma 3463:404967)
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M4.625 8L6.875 10.25L11.375 5.75M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" />
    </svg>
  );
}

export function EyeIcon({ size = 18, className = "", ...props }) {
  // eye — exported from the Figma password field's show-password toggle
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M1.81509 9.53488C1.71295 9.37315 1.66188 9.29229 1.63329 9.16756C1.61182 9.07387 1.61182 8.92613 1.63329 8.83244C1.66188 8.70771 1.71295 8.62685 1.81509 8.46512C2.65915 7.12863 5.17155 3.75 9.0003 3.75C12.8291 3.75 15.3415 7.12863 16.1855 8.46512C16.2877 8.62685 16.3387 8.70771 16.3673 8.83244C16.3888 8.92613 16.3888 9.07387 16.3673 9.16756C16.3387 9.29229 16.2877 9.37315 16.1855 9.53488C15.3415 10.8714 12.8291 14.25 9.0003 14.25C5.17155 14.25 2.65915 10.8714 1.81509 9.53488Z" />
      <path d="M9.0003 11.25C10.2429 11.25 11.2503 10.2426 11.2503 9C11.2503 7.75736 10.2429 6.75 9.0003 6.75C7.75766 6.75 6.7503 7.75736 6.7503 9C6.7503 10.2426 7.75766 11.25 9.0003 11.25Z" />
    </svg>
  );
}

export function EyeOffIcon({ size = 18, className = "", ...props }) {
  // eye-off — exported from the Figma password field's hide-password toggle
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M8.05721 3.81924C8.36202 3.77417 8.67645 3.75 9.00031 3.75C12.8291 3.75 15.3415 7.12863 16.1855 8.46512C16.2877 8.62688 16.3388 8.70776 16.3673 8.8325C16.3888 8.92619 16.3888 9.074 16.3673 9.16768C16.3387 9.29243 16.2873 9.37384 16.1844 9.53668C15.9595 9.89261 15.6166 10.3928 15.1624 10.9353M5.04324 5.03628C3.42169 6.13628 2.32084 7.66453 1.81583 8.46396C1.71321 8.6264 1.66191 8.70762 1.6333 8.83236C1.61182 8.92605 1.61181 9.07383 1.63328 9.16752C1.66187 9.29226 1.71295 9.37313 1.8151 9.53488C2.65916 10.8714 5.17156 14.25 9.00031 14.25C10.5441 14.25 11.8739 13.7007 12.9666 12.9575M2.25031 2.25L15.7503 15.75M7.40932 7.40901C7.00215 7.81618 6.75031 8.37868 6.75031 9C6.75031 10.2426 7.75767 11.25 9.00031 11.25C9.62163 11.25 10.1841 10.9982 10.5913 10.591" />
    </svg>
  );
}

export function AlertTriangleIcon({ size = 18, className = "", ...props }) {
  // alert-triangle (Figma 3463:405491)
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16.7502 14.5"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M8.37508 11.375H8.38258M8.37508 5.375V8.375M1.25174 14H15.4984C16.0819 14 16.4422 13.3569 16.1418 12.8516L9.0185 0.867854C8.72696 0.377382 8.0232 0.377382 7.73166 0.867854L0.608322 12.8516C0.307966 13.3569 0.668275 14 1.25174 14Z" />
    </svg>
  );
}

// Brand glyphs for the OAuth buttons, exact paths exported from the Figma social
// buttons. Each viewBox keeps the source coordinates so the glyph stays aligned.
// Apple (87657:22683) is a filled circular badge: the badge uses the reversed
// surface and the glyph the default surface, so both flip in dark mode (dark
// badge / white glyph in light, the inverse in dark) to stay legible on the
// tint-900 button. Google (87657:22684) is the bare four-color logo, no badge,
// with fixed brand colors per Google's guidelines.
const BADGE_FILL =
  "[fill:var(--color-surface-bg-default-dark)] dark:[fill:var(--color-surface-bg-default-light)]";
const GLYPH_FILL =
  "[fill:var(--color-surface-bg-default-light)] dark:[fill:var(--color-surface-bg-default-dark)]";

// Apple badge.
export function AppleIcon({ size = 18, className = "", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="137.125 12.125 15.75 15.75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        className={BADGE_FILL}
        d="M152.875 20C152.875 24.347 149.351 27.875 145 27.875C140.649 27.875 137.125 24.347 137.125 20C137.125 15.6491 140.649 12.125 145 12.125C149.351 12.125 152.875 15.6491 152.875 20Z"
      />
      <path
        className={GLYPH_FILL}
        d="M148.691 18.0073C148.648 18.0323 147.625 18.5614 147.625 19.7344C147.673 21.0722 148.916 21.5413 148.938 21.5413C148.916 21.5664 148.75 22.1804 148.257 22.8241C147.866 23.3785 147.432 23.9375 146.773 23.9375C146.147 23.9375 145.922 23.568 145.198 23.568C144.422 23.568 144.202 23.9375 143.607 23.9375C142.948 23.9375 142.482 23.3485 142.07 22.7993C141.534 22.0805 141.079 20.9524 141.063 19.8692C141.052 19.2952 141.17 18.731 141.47 18.2518C141.893 17.5827 142.649 17.1286 143.474 17.1136C144.106 17.0937 144.668 17.518 145.054 17.518C145.423 17.518 146.115 17.1136 146.896 17.1136C147.234 17.1139 148.134 17.2087 148.691 18.0073ZM145 16.999C144.888 16.4748 145.198 15.9507 145.488 15.6163C145.857 15.212 146.441 14.9375 146.945 14.9375C146.977 15.4617 146.773 15.9757 146.409 16.3501C146.082 16.7545 145.52 17.0589 145 16.999Z"
      />
    </svg>
  );
}

// Google four-color logo (no badge).
export function GoogleIcon({ size = 18, className = "", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="133 12.5 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#4285F4"
        d="M147.813 20.1624C147.813 19.5612 147.763 19.1224 147.655 18.6674H140.649V21.3811H144.762C144.679 22.0555 144.231 23.0712 143.236 23.7536L143.222 23.8445L145.437 25.5262L145.591 25.5412C147 24.2655 147.813 22.3886 147.813 20.1624Z"
      />
      <path
        fill="#34A853"
        d="M140.649 27.3125C142.664 27.3125 144.355 26.6625 145.59 25.5412L143.236 23.7537C142.606 24.1843 141.76 24.4849 140.649 24.4849C138.676 24.4849 137.001 23.2093 136.404 21.4462L136.317 21.4535L134.014 23.2004L133.983 23.2824C135.21 25.6712 137.731 27.3125 140.649 27.3125Z"
      />
      <path
        fill="#FBBC05"
        d="M136.404 21.4462C136.247 20.9912 136.156 20.5037 136.156 20C136.156 19.4962 136.247 19.0087 136.396 18.5537L136.392 18.4568L134.06 16.6819L133.983 16.7174C133.478 17.7087 133.188 18.8218 133.188 20C133.188 21.1781 133.478 22.2912 133.983 23.2824L136.404 21.4462Z"
      />
      <path
        fill="#EB4335"
        d="M140.649 15.515C142.05 15.515 142.996 16.1081 143.534 16.6038L145.64 14.5887C144.347 13.4106 142.664 12.6875 140.649 12.6875C137.731 12.6875 135.21 14.3287 133.983 16.7175L136.396 18.5537C137.001 16.7906 138.676 15.515 140.649 15.515Z"
      />
    </svg>
  );
}

export function ChevronDownIcon({ size = 18, className = "", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
